import React from 'react'
import '../assets/css/header2.css'

import image1 from '../assets/images/footer1.jpg'
import image2 from '../assets/images/footer2.jpg'
import image3 from '../assets/images/footer3.jpg'
import image4 from '../assets/images/footer4.jpg'
import image5 from '../assets/images/footer5.jpg'
import image6 from '../assets/images/footer6.jpg'
import { Link } from 'react-router-dom'

export default function Header2() {
  const imagesWithLinks = [
    {
      image: image1,
    },
    {
      image: image2,
    },
    {
      image: image3,
    },
    {
      image: image4,
    },
    {
      image: image5,
    },
    {
      image: image6,
    },
  ];
  return (
    <div className='Header2Padding'>
    <div className='Heading2'>
      <div>Share Your Meals on Instagram with <span>#LazyChef</span> & I Will Reward the Meal of the Month!</div>
    </div>
    <div className='container imagesHeader2'>
      <div className='row'>
        {imagesWithLinks.map((item, index) => (
          <div className='col-xl-2 col-lg-3 col-4 colss' key={index}>
            <figure>
              <Link to={'https://www.instagram.com'} target="_blank" rel="noopener noreferrer">
                <img src={item.image} alt={`Image ${index + 1}`} />
                <div className='overlay'>
                  <i className="fa-brands fa-square-instagram"></i>
                </div>
              </Link>
            </figure>
          </div>
        ))}
      </div>
    </div>
  </div>
  )
}
